





import { Component, Vue, Watch, Prop } from "vue-property-decorator";
@Component({})
export default class LineDrawing extends Vue {
  @Prop() cdata: any;
  @Prop() csetting: any;
  @Prop() cextend: any;
  chartSettings = {};
  chartData = {};
  chartExtend = {};

  @Watch("cdata", { deep: true, immediate: true })
  watchChartData(v: any) {
    this.chartData = v;
  }

  @Watch("csetting", { deep: true, immediate: true })
  watchChartSettings(v: any) {
    this.chartSettings = v;
  }

  @Watch("cextend", { deep: true, immediate: true })
  watchChartExtend(v: any) {
    this.chartExtend = v;
  }
}
